import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/app/node_modules/@vercel/analytics/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"_geist\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Geist_Mono\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"_geistMono\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/github-markdown-css/github-markdown.css");
;
import(/* webpackMode: "eager" */ "/app/app/globals.css");
